import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './app'
import store from '../../core/store'
import { AuthProvider } from '../../core/providers/AuthProvider'
import '../../core/i18n'

const Root = () => (
    <Provider store={store}>
        <AuthProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </AuthProvider>
    </Provider>
)

export default Root
